import React, { useEffect } from 'react'

export default function Checkbox({ object, formUse, handleFormData, data, prefilledData, viewOnly, rowIndex, colIndex }) {

    useEffect(() => {
        formUse && handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, false)
    }, [])

    return (
        <div className='d-flex gap-3 align-items-center' style={{ padding: "8px" }}>
            <input type='checkbox' id={object.content+"-"+rowIndex+colIndex}
                checked={prefilledData && prefilledData[object?.content] ? prefilledData[object?.content] : data && data[object?.content+"-"+rowIndex+colIndex] ? data[object?.content+"-"+rowIndex+colIndex] : false}
                disabled={prefilledData && prefilledData[object?.content] ? true : viewOnly ? viewOnly : false}
                onChange={(e) => { formUse && handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, e.target.checked) }} />
            <label htmlFor={object.content+"-"+rowIndex+colIndex}>{object.content}</label>
        </div>
    )
}
